// tslint:disable:max-line-length
import { Component, OnInit } from '@angular/core';
import { E5coreUiWorkFieldTypeTextBaseComponent } from '../../../components/e5core-ui-work-field-type-text/component/e5core-ui-work-field-type-text-base';

@Component({
  selector: 'e5core-ui-work-field-type-user-bootstrap',
  templateUrl: './e5core-ui-work-field-type-user-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-field-type-user-bootstrap.component.css']
})
export class E5coreUiWorkFieldTypeUserBootstrapComponent extends E5coreUiWorkFieldTypeTextBaseComponent {

}
